import './style.scss';
import { Checkbox, DatePicker, Radio } from 'antd';
import getFormatMessage from '../../../../../locales/get-format-message';
import { IAPIStudioInfo } from '../../../../../model/api-modules/studio';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import warnBlueIcon from '../../../../../assets/svg/warn-blue.svg';
import downloadBalanceIcon from '../../../../../assets/svg/download-balance.svg';
import {
  BalanceType,
  // IBalanceItem,
  IBalanceList,
} from '../../../../../model/billing-center/balance';
import { getLocalTime, getPrice } from '../../../../../lib';
import { downCSVTemplate } from '../../../../studio/organization-router/detail-table/member/lib/csv';
import { useHistory } from 'react-router-dom';
import { getBalanceInfoList } from '../../../../../api';
import { AutoTable } from '../../../../../components/auto-table';
import {
  IConfigField,
  IListItem,
} from '../../../../../components/auto-table/model';
import { renderFeeType } from '../../../../lib/fee';
import { ConsumeCostType } from '../../../../../model/billing-center';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
}

export const TransactionDetailsComponent = (props: IProps) => {
  const studioId = props.studioInfo.studio.StudioID;
  const [loading, setLoading] = useState<boolean>(false);
  const [isDateRangeSelected, setIsDateRangeSelected] =
    useState<boolean>(false);
  const [dateRange, setDateRange] = useState<string[]>([]);
  // const [balanceLists, setBalanceLists] = useState<any[]>([]);
  const [balanceList, setBalanceList] = useState<IBalanceList[]>([]);
  const [originalData, setOriginalData] = useState<IBalanceList[]>([]);

  // 筛选处理
  const isMounted = useRef(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [isZero, setIsZero] = useState<boolean>(true);
  const currentMonth = moment().format('YYYY-MM');
  const lastMonth = moment().subtract(1, 'month').format('YYYY-MM');
  const [isSelectMonth, setIsSelectMonth] = useState<boolean>(true);
  const [selectedMonth, setSelectedMonth] = useState<string | undefined>(
    currentMonth
  );
  const [isDisabledDown, setIsDisabledDown] = useState<boolean>(false);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const history = useHistory();

  const getWithDrawaList = async () => {
    setLoading(true);
    const startDate = dateRange[0] || selectedMonth || currentMonth;
    const endDate = dateRange[1] || selectedMonth || currentMonth;
    // console.log('start-dateRange[0] || selectedMonth || currentMonth',dateRange[0],selectedMonth, lastMonth);
    const res = await getBalanceInfoList(studioId, startDate, endDate, isZero);
    if (res) {
      const items: IBalanceList[] = res.list;
      setBalanceList(items);
      setOriginalData(items);
      // handleFilter(items);
    }
    setLoading(false);
  };

  const handleFilter = (currentList?: IBalanceList[]) => {
    const currentData = currentList || originalData;
    let filtered: IBalanceList[];
    if (isSelectMonth && !isDateRangeSelected) {
      filtered = currentData.filter((item) => {
        const createTime = moment(item.create_time, 'YYYY-MM');
        const dateRangeMatch =
          !isSelectMonth ||
          createTime.isBetween(currentMonth, currentMonth, null, '[]');
        return dateRangeMatch;
      });
      setBalanceList(filtered);
    } else {
      filtered = currentData.filter((item) => {
        const startDate = moment(dateRange[0], 'YYYY-MM');
        const endDate = moment(dateRange[1], 'YYYY-MM');
        const createTime = moment(item.create_time, 'YYYY-MM');
        const dateRangeMatch =
          !isDateRangeSelected ||
          createTime.isBetween(startDate, endDate, null, '[]');
        return dateRangeMatch;
      });
      setBalanceList(filtered);
    }
  };

  useEffect(() => {
    getWithDrawaList();
  }, [isZero, selectedMonth, dateRange]);

  useEffect(() => {
    const isDisabledDown = !(originalData.length > 0);
    setIsDisabledDown(isDisabledDown);
  }, [originalData]);

  useEffect(() => {
    // 初始化拿不到数据，不执行
    if (isMounted.current) {
      handleFilter();
      setLoading(false);
      if (isDateRangeSelected && dateRange.length > 0) {
        // 不能选中上下月筛选
        setIsSelectMonth(false);
        setSelectedMonth(undefined);
      } else {
        setIsSelectMonth(true);
      }
    } else {
      isMounted.current = true;
    }
  }, [dateRange, selectedMonth]);

  // 当月 下月
  const handleMonthChange = (month: string) => {
    setDateRange(['', '']);
    setIsDateRangeSelected(false);
    setIsSelectMonth(true);
    setSelectedMonth(month);
  };

  const handleDateRangeChange = (dates: any, dateStrings: string[]) => {
    if (!dates || dates.length === 0) {
      setDateRange(['', '']);
      setIsDateRangeSelected(false);
      // setBalanceList(originalData);

      setSelectedMonth(currentMonth); // 选中上月
      handleMonthChange(currentMonth); // 调用处理函数以更新表格数据
    } else {
      setDateRange(dateStrings);
      setIsDateRangeSelected(true);
    }
    handleFilter();
  };

  const getTradeAmount = (record: IBalanceList) => {
    const { status } = record;
    const symbol = status === BalanceType.Expenses ? '-' : '+';
    return {
      symbol,
      amount: getPrice(record.amount).amount,
      fullText: symbol + getPrice(record.amount).amount,
    };
  };
  const handleDownload = (record?: IBalanceList) => {
    if (isDisabledDown) {
      return;
    }
    let tableData = [];
    const getRow = (item: IBalanceList) => {
      return [
        getLocalTime(item.create_time, userInfo?.UserSettings?.Timezone) || '',
        item.id || '',
        getTradeAmount(item).fullText || '',
        renderStatus(item.status),
        renderFeeType(item.type),
        item.status === BalanceType.InCome
          ? getFormatMessage('income_channel')
          : getFormatMessage('express_channel'),
        item.balance || '',
        extractYearMonth(item.create_time),
        item.remark || '',
      ];
    };
    const title = [
      getFormatMessage('trading_hours'),
      getFormatMessage('serial_id'),
      getFormatMessage('trading_money'),
      getFormatMessage('income_and_expenditure_types'),
      getFormatMessage('trading_types'),
      getFormatMessage('trading_from'),
      getFormatMessage('available_amount'),
      getFormatMessage('bill_month'),
      getFormatMessage('remark'),
    ];
    if (record) {
      tableData = [title, getRow(record)];
    } else {
      tableData = [title, ...originalData.map((item) => getRow(item))];
    }
    const tableDataAsString = tableData.map((row) =>
      row.map((cell) => String(cell))
    );
    downCSVTemplate('balance_data', tableDataAsString);
  };

  const extractYearMonth = (value: string | Date | undefined): string => {
    if (!value) {
      return '';
    }
    const localTime = getLocalTime(value, userInfo?.UserSettings?.Timezone);
    return localTime.substring(0, 7); // 提取 YYYY-MM
  };

  const renderStatus = (status: string) => {
    const text =
      status === BalanceType.InCome
        ? getFormatMessage('income')
        : getFormatMessage('express');
    return text;
  };
  const handleCostBalanceClick = () => {
    history.push(`/studio/${studioId}/fee/billing-manage`);
  };

  const COLUMNS: IConfigField<IBalanceList>[] = [
    {
      name: getFormatMessage('trading_hours'),
      key: 'create_time',
      tableExtension: {
        renderRow(_key: any, value: string | Date | undefined) {
          return <>{getLocalTime(value, userInfo?.UserSettings?.Timezone)}</>;
        },
      },
    },
    {
      name: getFormatMessage('serial_id'),
      key: 'id',
    },
    {
      name: getFormatMessage('trading_money'),
      key: 'amount',
      tableExtension: {
        renderRow(_key: any, value: string, row: IListItem) {
          const record = row as IBalanceList;
          const { symbol, amount } = getTradeAmount(record);
          return (
            <span>
              <span style={{ marginRight: '3px' }}>{symbol}</span>
              {amount}
            </span>
          );
        },
      },
    },
    {
      name: getFormatMessage('income_and_expenditure_types'),
      key: 'status',
      tableExtension: {
        renderRow(_key: any, value: string) {
          const color = value === BalanceType.InCome ? '#40D4CF' : '';
          const text =
            value === BalanceType.InCome
              ? getFormatMessage('income')
              : getFormatMessage('express');
          return <span style={{ color }}>{text}</span>;
        },
      },
    },
    {
      name: getFormatMessage('trading_types'),
      key: 'type',
      tableExtension: {
        renderRow(_key: any, value: ConsumeCostType) {
          return <span>{renderFeeType(value)}</span>;
        },
      },
    },
    {
      name: getFormatMessage('trading_from'),
      key: 'channel',
      tableExtension: {
        renderRow(_key: any, _value, record) {
          const text =
            record.status === BalanceType.InCome
              ? getFormatMessage('income_channel')
              : getFormatMessage('express_channel');

          return text;
        },
      },
    },
    {
      name: getFormatMessage('available_amount'),
      key: 'balance',
      tableExtension: {
        renderRow(_key: any, value: string) {
          return <>{getPrice(value).amount}</>;
        },
      },
    },
    {
      name: getFormatMessage('bill_month'),
      key: 'create_time',
      tableExtension: {
        renderRow(_key: any, value: string | Date | undefined) {
          return <>{extractYearMonth(value)}</>;
        },
      },
    },
    {
      name: getFormatMessage('remark'),
      key: 'remark',
    },
    {
      name: getFormatMessage('operate'),
      key: 'action',
      tableExtension: {
        renderRow(_key: any, _value: any, row: IListItem) {
          const record = row as IBalanceList;
          return (
            <span className="link-url" onClick={() => handleDownload(record)}>
              {getFormatMessage('download_details')}
            </span>
          );
        },
      },
    },
  ];
  const onChangedFilterValues = () => {};
  const pageList = [...balanceList].slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  // console.log('originalData1111111111',originalData);
  return (
    <div className="bi-child-container bi-withdrawal-container">
      <div className="re-report-description">
        <img src={warnBlueIcon} className="warn-blue-icon" />
        <div className="re-report-text">
          {getFormatMessage('balance_desc_1')}
          <span className="withdrawal-blue" onClick={handleCostBalanceClick}>
            {getFormatMessage('balance_desc_bill_details')}
          </span>
          {getFormatMessage('balance_desc_2')}
        </div>
        <div className="re-report-text">
          {getFormatMessage('balance_desc_3')}
        </div>
        <div className="re-report-text">
          {getFormatMessage('balance_desc_4')}
        </div>
      </div>
      <div className="bi-recharge-bottom">
        <div className="recharge-title recharge-title-last">
          <button
            className="gc-btn gc-btn-default balance-container"
            disabled={isDisabledDown}
            onClick={() => handleDownload()}
          >
            <img src={downloadBalanceIcon} width={16} height={16} />
            {getFormatMessage('download_all')}
          </button>
          <div className="recharge-title balance-title">
            <Checkbox
              className="balance-select-zero"
              checked={!isZero}
              onChange={(e) => setIsZero(!e.target.checked)}
            >
              {getFormatMessage('not_show_0_cost')}
            </Checkbox>
            <Radio.Group
              className="balance-select-month"
              value={selectedMonth}
              onChange={(e) => handleMonthChange(e.target.value)}
            >
              <Radio.Button value={currentMonth}>
                {getFormatMessage('current_month')}
              </Radio.Button>
              <Radio.Button value={lastMonth}>
                {getFormatMessage('last_month')}
              </Radio.Button>
            </Radio.Group>
            <div className="billing-date-picker details-picker">
              <DatePicker.RangePicker
                dropdownClassName="fee-data-dropdown"
                value={
                  isDateRangeSelected
                    ? [moment(dateRange[0]), moment(dateRange[1])]
                    : null
                }
                picker="month"
                onChange={handleDateRangeChange}
                monthCellRender={(date) => {
                  return `${moment(date).format('MM')}`; // 修改中文显示为数字
                }}
              />
            </div>
          </div>
        </div>
        <AutoTable
          loading={loading}
          list={pageList || []}
          configFields={COLUMNS}
          tableExtension={{
            onChange: (changeInfo) => {
              if (!changeInfo) {
                return;
              }
              setCurrentPage(changeInfo.current);
              setPageSize(changeInfo.pageSize || 10);
            },
            pagination: {
              current: currentPage,
              total: balanceList.length,
              pageSize,
              showTotal: () => {
                return `Total ${balanceList.length} items`;
              },
            },
          }}
          layoutExtension={{
            showTopbar: false,
            showFilter: true,
          }}
          onChangedFilterValues={onChangedFilterValues}
          // className="re-report-table"
        />
      </div>
    </div>
  );
};
